import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { getGetEvalScoringStandardQueryKey, getListEvalRubricsQueryKey } from "@api/rest/types-and-hooks";

/**
 * Refresh everything an edit to the rubric changes.
 *
 * Two queries, not one. Editing a criterion can retire the active rubric and
 * create a new version, so it changes both the standard in force *and* the
 * version history — but those are separate query keys, and refetching the
 * standard alone left History stale until a full page reload. It also left
 * History hidden after the very first edit, since the list query still looked
 * empty and the table renders nothing when it is.
 *
 * Invalidating rather than refetching a single hook instance, so every
 * observer of either key updates wherever it is mounted.
 */
export const useRefreshRubric = (): (() => Promise<void>) => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: getGetEvalScoringStandardQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getListEvalRubricsQueryKey() }),
    ]);
  }, [queryClient]);
};
